/**
 * Fetcher & mutator pure functions untuk booking domain.
 * Subdomain: domestic, international, kalogistics.
 */
import http from "@/config/http";

/* ============================================================
 * Booking Domestic
 * ============================================================ */

export async function fetchBookingDomestic(params = {}) {
  const { data } = await http.get("/api/v1/booking/domestic/get", { params });
  return data;
}

export async function fetchBookingDomesticById(id) {
  const { data } = await http.get(`/api/v1/booking/domestic/get/${id}`);
  return data;
}

export async function createBookingDomestic(payload) {
  const { data } = await http.post("/api/v1/booking/domestic/create", payload);
  return data;
}

export async function updateBookingDomestic({ id, payload }) {
  const { data } = await http.put(
    `/api/v1/booking/domestic/update/${id}`,
    payload
  );
  return data;
}

export async function deleteBookingDomestic(id) {
  const { data } = await http.delete(`/api/v1/booking/domestic/delete/${id}`);
  return data;
}

/* ============================================================
 * Booking International
 * ============================================================ */

export async function fetchBookingInternational(params = {}) {
  const { data } = await http.get("/api/v1/booking/international/get", {
    params,
  });
  return data;
}

export async function fetchBookingInternationalById(id) {
  const { data } = await http.get(`/api/v1/booking/international/get/${id}`);
  return data;
}

export async function createBookingInternational(payload) {
  const { data } = await http.post(
    "/api/v1/booking/international/create",
    payload
  );
  return data;
}

export async function updateBookingInternational({ id, payload }) {
  const { data } = await http.put(
    `/api/v1/booking/international/update/${id}`,
    payload
  );
  return data;
}

export async function deleteBookingInternational(id) {
  const { data } = await http.delete(
    `/api/v1/booking/international/delete/${id}`
  );
  return data;
}

/* ============================================================
 * Booking Kalogistics
 * ============================================================ */

export async function fetchBookingKalogistics(params = {}) {
  const { data } = await http.get("/api/v1/booking/kalogistics", { params });
  return data;
}

export async function fetchBookingKalogisticsOrigins() {
  const { data } = await http.get("/api/v1/booking/kalogistics/origins");
  return data;
}

export async function fetchBookingKalogisticsDestinations(originId) {
  const { data } = await http.get(
    `/api/v1/booking/kalogistics/destinations/${originId}`
  );
  return data;
}

export async function fetchBookingKalogisticsById(id) {
  const { data } = await http.get(`/api/v1/booking/kalogistics/${id}`);
  return data;
}

export async function approveBookingKalogistics({ id, payload }) {
  const { data } = await http.put(
    `/api/v1/booking/kalogistics/approve/${id}`,
    payload
  );
  return data;
}
